import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {CampaignNotAssignedModal} from "../client/CampaignNotAssignedModal";
import { withTranslation } from 'react-i18next';

export class BusinessUnitAdAccountGeneralAlertIconClass extends Component {
    constructor(props) {
        super(props);

        this.campaignsNotAssignedUpdated = this.campaignsNotAssignedUpdated.bind(this);
    }

    render() {
        return (
            <div className={this.cssClassName()}>
                <FaIcon iconName="exclamation-triangle"/>
                {this.renderAlertTooltip()}
            </div>
        )
    }

    hasAlert() {
        return this.props.hasCampaignsNotAssignedAlert || this.props.hasImpresionAlert || this.props.hasNoAccessAlert
    }

    renderAlertTooltip() {
        const content = this.hasAlert() ? this.alertMessage() : (this.hasInfo() ? this.infoMessage() : null);

        if (content) {
            return <div className="bu-tooltip">
                <FaIcon iconName="exclamation-triangle"/>
                <p className="tooltip-description">
                    {content}
                </p>
            </div>;
        }
    }

    hasInfo() {
        return this.props.hasCampaignsNotAssignedAlertSnoozed;
    }

    cssClassName() {
        if (this.hasAlert()) {
            return "bu-cell-icon no-impressions-alert"
        } else if (this.hasInfo()){
            return "bu-cell-icon has-info"
        } else {
            return "bu-cell-icon"
        }
    }

    campaignsNotAssignedUpdated() {
        const { t } = this.props;
        alert(t('bucc_general_alert_tooltip.changes_saved_successfully'));
        this.props.doParentReReder();
    }

    infoMessage() {
        if (this.props.hasCampaignsNotAssignedAlertSnoozed) {
            return this.renderCampaignsNotAssignedMessage();
        }
    }

    renderCampaignsNotAssignedMessage() {
        const { t } = this.props;
        return (
            <span style={{display: "inline-flex", alignItems: "center"}}>
                    <span style={{marginRight: "0px"}}>{t('bucc_general_alert_tooltip.account_has_unassigned_campaigns')}</span>
                    <CampaignNotAssignedModal onFormSubmitted={this.campaignsNotAssignedUpdated}
                                              businessUnitId={this.props.businessUnitId}/>
                </span>);
    }

    alertMessage() {

        if (this.props.hasNoAccessAlert)
            return this.props.hasNoAccessAlert;

        let alertsComponents = [];

        if (this.props.hasImpresionAlert) {
            const { t } = this.props;
            alertsComponents.push(<span>{t('bucc_general_alert_tooltip.account_has_no_impressions')}</span>);
        }

        if (this.props.hasCampaignsNotAssignedAlert) {
            if (alertsComponents.length > 0)
                alertsComponents.push(<br/>);

            alertsComponents.push(
                this.renderCampaignsNotAssignedMessage());
        }

        return (alertsComponents);
    }
}

export const BusinessUnitAdAccountGeneralAlertIcon = withTranslation()(BusinessUnitAdAccountGeneralAlertIconClass);
export default BusinessUnitAdAccountGeneralAlertIcon;
